(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snow-effect"] && !Shopify.designMode) return;
  try {
    //snow fall script

  (function () {
    const canvas = document.getElementById('snowCanvas');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');

    let w = window.innerWidth;
    let h = window.innerHeight;
    canvas.width = w;
    canvas.height = h;

    const flakes = [];
    const flakesCount = Math.min(150, Math.floor(w / 10)); // responsive count

    let mouseX = 0;
    let mouseY = 0;

    // mouse position ko -1 se 1 range me normalize karenge
    let mouseFactorX = 0;
    let mouseFactorY = 0;

    // Resize handle
    window.addEventListener('resize', () => {
      w = window.innerWidth;
      h = window.innerHeight;
      canvas.width = w;
      canvas.height = h;
    });

    // Mouse move listener
    window.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;

      mouseFactorX = (mouseX / w - 0.5) * 2; // -1 to 1
      mouseFactorY = (mouseY / h - 0.5) * 2; // -1 to 1
    });

    // Mobile ke liye thoda support (touch move)
    window.addEventListener('touchmove', (e) => {
      const touch = e.touches[0];
      if (!touch) return;
      mouseX = touch.clientX;
      mouseY = touch.clientY;

      mouseFactorX = (mouseX / w - 0.5) * 2;
      mouseFactorY = (mouseY / h - 0.5) * 2;
    });

    // Snowflake object
    function Snowflake() {
      this.reset();
    }

    Snowflake.prototype.reset = function () {
      this.x = Math.random() * w;
      this.y = Math.random() * h - h;
      this.radius = 1 + Math.random() * 3;
      this.speedY = 0.5 + Math.random() * 1.5;
      this.windOffset = Math.random() * 0.5;
      this.opacity = 0.4 + Math.random() * 0.6;
    };

    Snowflake.prototype.update = function () {
      // mouse ke hisaab se halki hawa
      const windX = mouseFactorX * 1.2 + this.windOffset;
      const driftY = mouseFactorY * 0.3; // halka vertical effect

      this.x += windX;
      this.y += this.speedY + driftY;

      // Screen se bahar gaya to reset
      if (this.y > h + 10 || this.x < -10 || this.x > w + 10) {
        this.reset();
        this.y = -10;
      }
    };

    Snowflake.prototype.draw = function () {
      ctx.beginPath();
      ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
ctx.fillStyle = 'rgba(255,255,255,' + this.opacity + ')';
ctx.fill();


    };

    // Snowflakes create karo
    for (let i = 0; i < flakesCount; i++) {
      flakes.push(new Snowflake());
    }

    // Animation loop
    function animate() {
      ctx.clearRect(0, 0, w, h);
      for (let i = 0; i < flakes.length; i++) {
        flakes[i].update();
        flakes[i].draw();
      }
      requestAnimationFrame(animate);
    }

    animate();
  })();
  } catch(e) { console.error(e); }
})();

})();
